import "twin.macro";
import React from "react";
import Layout from "../components/Layout";
import HeroSection from "../components/ResumeTemplate/HeroSection";
import GetIndustryStandardSection from "../components/ResumeTemplate/GetIndustryStandardSection";
import PortfolioSection from "../components/ResumeTemplate/PortfolioSection";
import ListofPortfolio from "../components/ResumeTemplate/ListofPortfolio";
import Seo from "../components/Seo";
const ResumeTempaltem = () => {
  return (
    <Layout tw="bg-gray-700">
      <Seo title="Portfolio" description="Digital Portfoliois one of the most efficient way to present your skill to a client or a job which you are looking for this portfolio not only tells about your skill but also about your story and most important projects. Best portfolio design of all categories of your preference. Select now! And get started!" />
      <div tw="pt-20 md:pt-32"></div>
      <HeroSection />
      <GetIndustryStandardSection />
      <ListofPortfolio />
      <PortfolioSection />
    </Layout>
  );
};

export default ResumeTempaltem;
